import React from 'react'
import { Box, Heading, Text, Image } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { useStaticQuery, graphql } from 'gatsby'
import { get } from 'lodash'

const CDPSection = () => {
  const { t } = useTranslation('home')
  const images = useStaticQuery(graphql`
    query {
      cdp: file(relativePath: { eq: "home/customer_plataform.png" }) {
        publicURL
      }
    }
  `)

  const cdp = get(images, 'cdp.publicURL')

  return (
    <Box
      as="section"
      pt={[10, 20, 32]}
      px={[5, 5, 0]}
      pb={[16, 30, 35]}
      sx={{
        backgroundImage: 'url(/purpleBg.png)',
        backgroundPosition: 'bottom center',
        backgroundRepeat: 'repeat-y',
        backgroundSize: 'cover'
      }}
    >
      <Box maxWidth="container" width={1} mx="auto">
        <Heading mb={[6, 5]} variant="level2" color="white">
          {t('cdp.title')}
        </Heading>

        <Text as="p" maxWidth={['unset', '80%', '588px']} color="white" lineHeight="170%">
          {t('cdp.subtitle')}
        </Text>

        <Image width={1} mt={[10, -5, -12]} src={cdp} />
      </Box>
    </Box>
  )
}

export default CDPSection
